import type { ENV } from "@monta/env";
import { fixString } from "./fixString";

export const fixBaseURL = (url: string, baseURL?: keyof ENV): string => {
  if (!url || !baseURL) return url;
  return fixString(url, baseURL);
};
